module.exports = __webpack_public_path__ + "img/credit_avai.2889ba48.svg";